import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import OfficersAndPSCsInput from './OfficersAndPSCsInput';

const OfficersAndPSCsInputController = ({
  name = "officers_and_pscs",
  label = "Engagement Resolution List",
  helptext,
}) => {

  const { control, setValue, formState: { errors } } = useFormContext();
  const company_number = useWatch({ control, name: 'company_number' });

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      render={({ field }) => (
        <OfficersAndPSCsInput
          {...field}
          label={label}
          errors={errors}
          helptext={helptext}
          company_number={company_number}
          onChange={(people) => {
            setValue(field.name, people);
          }}
        />
      )}
    />
  );
};

export default OfficersAndPSCsInputController;
